import {Platform} from 'react-native';
import {differenceInDays} from 'date-fns';
import {get} from 'lodash';

import VisitWebsitePopover from '/component/partial/VisitWebsitePopover/VisitWebsitePopover';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {openURL, openURLInNewTabOnWeb} from '/util/linking.util';

import {
  GenerateOnLearnMoreParams,
  GenerateOnLearnMoreReturnParams,
} from '../BusinessBuilderBonusBanner/BusinessBuilderBonusBanner.types';

import {CheckFulfillmentProps} from './IncentiveTripBanner.types';

export const generateOnLearnMore = ({
  popoverShow = () => {},
  currentScreen = '',
}: GenerateOnLearnMoreParams): GenerateOnLearnMoreReturnParams => {
  const destinationURL =
    'https://coachanswers.optavia.com/help/incentive-trip-2024';
  return () => {
    if (Platform.OS === 'web') {
      openURLInNewTabOnWeb(destinationURL);
      return;
    }

    popoverShow(VisitWebsitePopover, {
      currentScreen: currentScreen,
      destinationURL,
      onSubmit: () => openURL('url', destinationURL),
    });
  };
};

export function getDaysLeftForBonus(currentDate: any, endDate: any) {
  return differenceInDays(new Date(endDate), new Date(currentDate));
}

export function getMonthName(date: any) {
  const dateUtil = getDateUtilDefaultInstance();
  const formattedMonth = dateUtil.formatDate(new Date(date), 'MMM');
  return formattedMonth;
}

export const checkFulfillment = ({
  path = 0,
  rankAchievements = [],
  orderingEntities = {currentCount: 0, targetCount: 0},
  fqv = {currentVolume: '0', targetVolume: '0'},
  newCoachCount = {currentCount: 0, targetCount: 0},
  supportPathCount = {currentCount: 0, targetCount: 0},
  showIncentiveUpdate = false,
}: CheckFulfillmentProps) => {
  const successfulRankMonth = rankAchievements?.filter(
    (month: any) => month.status,
  );
  const isRankAchieved = showIncentiveUpdate
    ? successfulRankMonth?.length >= 1
    : successfulRankMonth?.length >= 2;
  const isOrderingEntitiesQualified =
    get(orderingEntities, 'currentCount', 0) >=
    get(orderingEntities, 'targetCount', 0);
  const isFqvQualified = showIncentiveUpdate
    ? true
    : get(fqv, 'currentVolume', 0) >= get(fqv, 'targetVolume', 0);
  const isNewCoachQualified = showIncentiveUpdate
    ? true
    : get(newCoachCount, 'currentCount', 0) >=
      get(newCoachCount, 'targetCount', 0);
  const isSupportPathQualified =
    get(supportPathCount, 'currentCount', 0) >=
    get(supportPathCount, 'targetCount', 0);
  switch (path) {
    case 1:
      return (
        isRankAchieved &&
        isOrderingEntitiesQualified &&
        isFqvQualified &&
        isNewCoachQualified
      );
    case 2:
      return (
        isRankAchieved && isOrderingEntitiesQualified && isNewCoachQualified
      );
    case 3:
      return (
        isRankAchieved && isOrderingEntitiesQualified && isNewCoachQualified
      );
    case 4:
      return (
        isRankAchieved &&
        isOrderingEntitiesQualified &&
        isNewCoachQualified &&
        isSupportPathQualified
      );
    case 5:
      return (
        isRankAchieved && isOrderingEntitiesQualified && isSupportPathQualified
      );
  }
  return false;
};
